import { render, staticRenderFns } from "./ScoringInput.vue?vue&type=template&id=3e217db1&scoped=true&"
import script from "./ScoringInput.vue?vue&type=script&lang=js&"
export * from "./ScoringInput.vue?vue&type=script&lang=js&"
import style0 from "./ScoringInput.vue?vue&type=style&index=0&id=3e217db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e217db1",
  null
  
)

export default component.exports